import { IFormService } from "../../service/form/FormService";

export default class GetBoFormTypesInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(reportingPeriodApplicantId: number) {
    return this.formService.getBoFormTypes(reportingPeriodApplicantId);
  }
}
